import { ScreenSize } from '../utilities/style-utils';
import { Action } from '../types';

export const screenSizeUpdated = (screenSize: ScreenSize): Action => ({
  type: 'SCREEN_SIZE_UPDATED',
  screenSize,
});
